export var SpaceAsCodeAction;
(function (SpaceAsCodeAction) {
    SpaceAsCodeAction["CREATE"] = "CREATE";
    SpaceAsCodeAction["UPDATE"] = "UPDATE";
    SpaceAsCodeAction["NO_CHANGES"] = "NO_CHANGES";
})(SpaceAsCodeAction || (SpaceAsCodeAction = {}));
//# sourceMappingURL=spaces.js.map